import Icon from "../../../controls/Icon";
import * as React from "react";
import { Button } from "react-bootstrap";
function FixedItem(props) {
    const { t, id, editable, onDismiss, height, width } = props;
    const dismissWidget = React.useCallback(() => {
        if (onDismiss !== undefined) {
            return onDismiss(id);
        }
    }, [id, onDismiss]);
    const classes = [
        "fixed-item",
        `packery-height-${height}`,
        `fixed-width-${width}`,
    ];
    if (editable) {
        classes.push("packery-editmode");
    }
    return (React.createElement("div", { className: classes.join(" ") },
        props.children,
        React.createElement("div", { className: "packery-buttons" }, onDismiss !== undefined && editable ? (React.createElement(Button, { className: "btn-embed", onClick: dismissWidget },
            React.createElement(Icon, { name: "close-slim" }))) : null)));
}
export default FixedItem;
